module.exports = __webpack_public_path__ + "static/media/0-3.1c461f5a.svg";